import "./style.scss";
import * as _ from "lodash";
import * as React from "react";

import Section from "../../../../core/Section";
import Row from "../../../../core/Row";
import { Select, DatePicker, Input, Checkbox } from "../../../../form";
import { Form, Icon, Popover } from "antd";
import FtpOption from "./ftp";
import EmailOption from "./email";

const FormItem = Form.Item;

interface IEndpointMap {
  [key: string]: number;
}

const epMap: IEndpointMap = {
  email: 0,
  ftp: 1,
  sftp: 2
};

class ReportEndpoint extends React.Component<any, {}> {
  toggleFtp(e: any) {
    this.props.toggleFtp();
    this.updateValidation("ftp");
  }

  toggleSftp(e: any) {
    this.props.toggleSftp();
    this.updateValidation("sftp");
  }

  toggleEmail(e: any) {
    this.props.toggleEmail();
    this.updateValidation("email");
  }

  handleChange(target: string, e: any) {
    this.props.editEndpoint(target, e.target.name, e.target.value);
  }

  updateValidation(endpoint: string) {
    let current = this.props.form.getFieldValue("endpoints");
    current[epMap[endpoint]] = !current[epMap[endpoint]];
    this.props.form.setFieldsValue({ endpoints: current });
    this.props.form.validateFields(["endpoints"]);
  }

  validateEndpoints(rule: any, endpoints: boolean[], callback: any) {
    return endpoints.indexOf(true) != -1
      ? callback()
      : callback("At least one endpoint must be selected");
  }

  getCheckedEndpoints() {
    return [
      this.props.ftp.checked,
      this.props.sftp.checked,
      this.props.email.checked
    ];
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Section className="endpoint-options" title="Delivery Destinations">
        <FormItem
          className="endpoint-validation"
          help="Please select at least one destination for your report."
        >
          {getFieldDecorator("endpoints", {
            rules: [{ validator: this.validateEndpoints }],
            initialValue: this.getCheckedEndpoints()
          })(<span></span>)}
        </FormItem>
        <Row>
          <div className="label left">
            <FormItem>
              <Checkbox
                label="Email"
                handleChange={this.toggleEmail.bind(this)}
                checked={this.props.email.checked}
              />
              <Popover
                placement="topLeft"
                content={
                  "Reports will be sent as an email attachment, provided the size is smaller than 7MB."
                }
                title="Help"
                trigger="hover"
              >
                <Icon type="question-circle" />
              </Popover>
            </FormItem>
          </div>

          <EmailOption
            option="email"
            handleChange={this.handleChange.bind(this, "email")}
            disabled={!this.props.email.checked}
            form={this.props.form}
            {...this.props.email.details}
          />
        </Row>
        <Row>
          <div className="label left">
            <Checkbox
              label="FTP"
              handleChange={this.toggleFtp.bind(this)}
              checked={this.props.ftp.checked}
            />
          </div>

          <FtpOption
            option="ftp"
            handleChange={this.handleChange.bind(this, "ftp")}
            disabled={!this.props.ftp.checked}
            form={this.props.form}
            {...this.props.ftp.details}
          />
        </Row>

        <Row>
          <div className="label left">
            <Checkbox
              label="Secure FTP"
              handleChange={this.toggleSftp.bind(this)}
              checked={this.props.sftp.checked}
            />
          </div>

          <FtpOption
            option="sftp"
            handleChange={this.handleChange.bind(this, "sftp")}
            disabled={!this.props.sftp.checked}
            form={this.props.form}
            {...this.props.sftp.details}
          />
        </Row>
      </Section>
    );
  }
}

export default ReportEndpoint;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageTwo/ReportEndpoint/component.tsx